import { TranslationFunction } from 'i18next'
import React, { SFC } from 'react'

import { ReviewType } from '../../../front-face/models'
import { Smile } from '../../../front-face/shared'

type Props = {
  value: number
  reviewType: ReviewType
  t: TranslationFunction
}

export const OutputSmileOrValue: SFC<Props> = ({ value, reviewType, t }) => {
  if (reviewType === ReviewType.MidYear) {
    return <Smile value={value} t={t} />
  }

  return <span>{value}%</span>
}



// WEBPACK FOOTER //
// ./src/app/shared/components/outputs/output-smile-or-value.tsx